import { withFormik } from 'formik'
import * as Yup from 'yup'
import React, { useRef, useEffect, useState, useMemo } from 'react'
import { bool, number, object, string } from 'yup'
import Button from '../../atoms/Button/Button'
import FormCheckbox from '../../atoms/FormCheckBox/FormCheckBox'
import FormError from '../../atoms/FormError/FormError'
import FormGroup from '../../atoms/FormGroup/FormGroup'
import FormGroupInput from '../../atoms/FormGroupInput/FormGroupInput'
import FormGroupTextArea from '../../atoms/FormGroupTextArea/FormGroupTextArea'
import ScrollToError from '../../behaviours/ScrollToError'
import Modal from '../../components/Modal/Modal'
import {
    HARTU_FACILITY_PHONE,
    HARTU_FACILITY_SPACE,
    FIELD_TYPES
} from '../../constants/hartu'
import STATES from '../../constants/states'
import t from '../../i18n/translations/translations'
import AcceptPolicyLabel from '../AcceptPolicyLabel'
import AcceptPolicyLabelInstance77 from '../AcceptPolicyLabelInstance77'
import './HartuFacilityBookingForm.css'
import MiPagoModal from '../../components/MiPagoModal/MiPagoModal'
import TributariaModal from '../../components/TributariaModal/TributariaModal'
import PrecioCambiado from '../../components/PrecioCambiado/PrecioCambiado'
import HartuDateTimeBanner from '../../components/Hartu/HartuDateTimeBanner/HartuDateTimeBanner'
import { useDispatch, useSelector } from 'react-redux'
import { calculateDiscount } from '../../store/actions'
import { useLoading } from '../../context/LoadingContext/LoadingContext';
import HartuFacilityDynamicForm from './HartuFacilityDynamicForm';
import ErrorModal from '../../components/ErrorModal/ErrorModal';
import { setHartuErrorModal } from '../../store/actions';
import { validateDNI } from '../../constants/validateDNI'

const HartuFacilityBookingForm = withFormik({
    displayName: 'HartuFacilityBookingForm',
    validateOnChange: false,
    validateOnBlur: false,
    enableReinitialize: true,
    handleSubmit: (values, formikBag) => {
        if (typeof formikBag.props.handleSubmit !== 'function') {
            return
        }
        formikBag.props.handleSubmit(values)
    },
    mapPropsToValues: (props) => ({
        accept_policy: false,
        dates: props.dates,
        facilityName: props.facilityName,
        id_facility: props.id_facility,
        id_instancia: props.id_instancia,
        people: props.people || 1,
        type: props.facilityType,
        lang: props.lang,
        price: props.initialValues?.price || 0,
        total_price: props.initialValues?.price || 0,
        price_with_light: props.initialValues?.lightPrice || 0,
        has_light: props.has_light,
        single_space: props.single_space,
        phone_mandatory: props.phone_mandatory,
        id_facility_category: props.id_facility_category,
        hasLightCheck: false,
        id_user: props.initialValues?.id_user || null,
        facility_type: props.initialValues?.facility_type || null,
        can_pay_later: props.can_pay_later || true,
        abonado: props.initialValues?.abonado ?? 0,
        dynamicValues: props.dynamicFields?.reduce((acc, f) => {
            acc[f.name] = props.initialValues?.dynamicValues?.[f.name] || f.default_value || '';
            return acc;
        }, {}) || {},
    }),

    validationSchema: (props) => {
        const { lang, phone_mandatory, id_facility_category } = props

        // Función auxiliar para construir el validador de un campo dinámico
        const buildDynamicFieldValidator = (field, lang) => {
            let validator = Yup.string()
                .transform(v => (v == null ? '' : String(v)))
                .trim();

            // Aplicar validación requerida
            if (field.required) {
                validator = validator.required(
                    lang === 'es'
                        ? 'Este campo es obligatorio'
                        : 'Eremu hau nahitaezkoa da'
                );
            } else {
                validator = validator.notRequired();
            }

            // Aplicar validación regex si existe
            if (field.validation?.react) {
                const regexStr = field.validation.react;
                // Limpiar la regex: remover slashes al inicio y final
                const cleanRegex = regexStr.replace(/^\/|\/$/g, '');
                try {
                    const regex = new RegExp(cleanRegex);
                    validator = validator.matches(
                        regex,
                        lang === 'es'
                            ? `${field.title} no tiene un formato válido`
                            : `${field.title} ez da formatu balido`
                    );
                } catch (e) {
                    console.warn(`Regex inválida para campo ${field.name}:`, regexStr);
                }
            }

            // Validación adicional para el campo DNI usando validateDNI
            if (field.name === 'dni') {
                validator = validator.test(
                    'valid-dni',
                    lang === 'es'
                        ? 'DNI no válido'
                        : 'NAN ez da zuzena',
                    (value) => {
                        if (!value) {
                            return true; // Permitir vacío si no es requerido
                        }
                        const result = validateDNI(value);
                        return result.valid;
                    }
                );
            }

            return validator;
        };

        return object().shape({
            accept_policy: bool().oneOf([true], t.error_accept_policy[lang]),
            // Validación dinámica
            dynamicValues: Yup.lazy((val) => {
                const shape = {};
                (props.dynamicFields || []).forEach(f => {
                    shape[f.name] = buildDynamicFieldValidator(f, lang);
                });

                return Yup.object().shape(shape);
            })
        })
    },
})(({
    closeForm,
    dates,
    errorBookingCode,
    errors,
    facilityName,
    handleChange,
    handleSubmit,
    lang,
    maxPeople,
    id_instancia,
    id_facility,
    setFieldValue,
    setTouched,
    setErrors,
    state,
    time,
    touched,
    validateForm,
    values,
    can_pay_later,
    payment_type,
}) => {
    console.log(maxPeople);
    const [isModalOpen, setModalOpen] = useState(false)
    const [isModalTributariaOpen, setModalTributariaOpen] = useState(false)
    const [dynamicFields, setDynamicFields] = useState([]);
    const [dynamicFieldsValues, setDynamicFieldsValues] = useState([]);
    const [isMiPagoModal, setMiPagoModal] = useState(false)
    const [isPriceChanged, setPriceChange] = useState(false)
    const { setLoading } = useLoading();
    const { errorModal } = useSelector(state => state.hartu);
    const [dynamicValidationSchema, setDynamicValidationSchema] = useState(null);
    const [isFormReady, setIsFormReady] = useState(false);
    const [formLoaded, setFormLoaded] = useState(false);

    const singleSpace = values.single_space;

    const userId = sessionStorage.getItem('uzky');

    const handleClose = () => {
        setModalOpen(false)
    }

    const handleTributariaClose = () => {
        setModalTributariaOpen(false)
    }

    const handleOpenTributaria = () => {
        setLoading(false);
        if (isPriceChanged === true && tributariaPrice === 0) {
            setModalTributariaOpen(false)
            setMiPagoModal(false)
            setPriceChange(false)
            setTotalPrize(0);
            values.total_price = 0;
            setTimeout(() => {
                setModalOpen(true)
            }, 0)
            return
        }
        setModalTributariaOpen(true)
    }

    const numBookings = Array.isArray(dates) ? dates.length : 1;

    const [totalPrize, setTotalPrize] = useState(0)
    const [tributariaPrice, setTributariaPrice] = useState(0)
    const [showHasLightCheckbox, setShowHasLightCheckbox] = useState(false)
    const [isPhoneMandatory, setPhoneMandatory] = useState(false)
    const [userPriceData, setUserPriceData] = useState(null);

    const [limitBookingsMonthReached, setLimitBookingsMonthReached] = useState(false);
    const [limitBookingsDayReached, setLimitBookingsDayReached] = useState(false);
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
    const submitButtonRef = useRef(null);
    const [limitBookingsMonth, setLimitBookingsMonth] = useState(0);
    const [limitBookingsDay, setLimitBookingsDay] = useState(0);
    const [tributariaPrices, setTributariaPrices] = useState(null);
    const lightChecked = values.dynamicValues?.light;

    useEffect(() => {
    const fetchForm = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL_BASE}hartu/frontend/getForm`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "x-api-key": sessionStorage.getItem('instancek'),
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    },
                    body: JSON.stringify({
                        id_facility: parseInt(id_facility, 10),
                        id_instancia: parseInt(id_instancia, 10),
                        language: lang || 'es',
                        sid: sessionStorage.getItem('uzky') || null
                    }),
                }
            );

            const text = await response.text();

            let data;

            try {
                data = JSON.parse(text);
            } catch (e) {
                console.error("Respuesta no JSON:", text);
                return;
            }

            if (!response.ok) {
                console.error("Error API:", data);
                return;
            }

            const formFields = (data?.data?.form || []).filter(
                field => field.show_in_form !== false
            );

            setDynamicFields(formFields);

            if (data?.data?.user_price) {
                setUserPriceData(data.data.user_price);
            }

            setTributariaPrices(data?.data?.tributaria_prices || null);

            if (formFields.length > 0) {
                const buildDynamicFieldValidator = (field) => {
                    let validator = Yup.string()
                        .transform(v => (v == null ? '' : String(v)))
                        .trim();

                    if (field.required) {
                        validator = validator.required(
                            lang === 'es'
                                ? 'Este campo es obligatorio'
                                : 'Eremu hau nahitaezkoa da'
                        );
                    } else {
                        validator = validator.notRequired();
                    }

                    if (field.validation?.react) {
                        const regexStr = field.validation.react;
                        const cleanRegex = regexStr.replace(/^\/|\/$/g, '');

                        try {
                            const regex = new RegExp(cleanRegex);

                            validator = validator.matches(regex, {
                                message:
                                    lang === 'es'
                                        ? `${field.title} no tiene un formato válido`
                                        : `${field.title} ez da formatu balido`,
                                excludeEmptyString: true
                            });
                        } catch (e) {
                            console.warn(`Regex inválida para campo ${field.name}:`, regexStr);
                        }
                    }

                    if (field.name === 'dni') {
                        validator = validator.test(
                            'valid-dni',
                            lang === 'es'
                                ? 'DNI no válido'
                                : 'NAN ez da zuzena',
                            (value) => {
                                if (!value) {
                                    return true;
                                }
                                const result = validateDNI(value);
                                return result.valid;
                            }
                        );
                    }

                    if (field.name === 'people') {
                        validator = validator.test(
                            'max-people',
                            t.error_capacity_persons[lang].replace(
                                '%s',
                                maxPeople
                            ),
                            (value) => {
                                return Number(value) <= maxPeople;
                            }
                        );
                    }

                    return validator;
                };

                const dynamicShape = {};
                formFields.forEach(f => {
                    dynamicShape[f.name] = buildDynamicFieldValidator(f);
                });

                setDynamicValidationSchema(Yup.object().shape(dynamicShape));
            }

            setFormLoaded(true);
            if (data?.data?.tributaria_prices == null && data?.data?.user_price == null) {
                let button = document.querySelector('.hartuBookingform__submit button');
                if (button){
                    button.textContent = t.action_calculate_price[lang];
                }

                let priceDiv = document.querySelector('.hartuBookingform__discounts--wrapper');
                if (priceDiv){
                    priceDiv.remove();
                }
            }
        } catch (error) {
            console.error("Error en getForm:", error);
        }
    };

    if (id_facility && id_instancia) {
        fetchForm();
    }
}, [id_facility, id_instancia, lang]);

    // Sincronizar valores por defecto cuando se cargan los campos dinámicos (solo iniciales)
    useEffect(() => {
        if (!formLoaded || !dynamicFields.length) return;

        dynamicFields.forEach(field => {
            const fieldName = field.name;
            const currentValue = values.dynamicValues?.[fieldName];

            if (currentValue === undefined || currentValue === '') {
                let defaultValue = field.default_value;

                if (field.type?.toUpperCase() === FIELD_TYPES.CHECKBOX) {
                    defaultValue = typeof defaultValue === 'boolean'
                        ? defaultValue
                        : false;
                }
                setFieldValue(`dynamicValues.${fieldName}`, defaultValue);
            }
        });
        setIsFormReady(true);
    }, [formLoaded, dynamicFields, setFieldValue]); // Depende solo de la cantidad de campos, no de los campos en sí

    useEffect(() => {
        const buttonEl = submitButtonRef.current?.querySelector('button');
        if (!buttonEl) return;

        if (limitBookingsMonthReached || limitBookingsDayReached) {
            setIsSubmitEnabled(false);
            submitButtonRef.current.querySelector('button')?.style.setProperty('cursor', 'not-allowed');
        } else {
            setIsSubmitEnabled(true);
            submitButtonRef.current.querySelector('button')?.style.setProperty('cursor', 'pointer');
        }
    }, [limitBookingsMonthReached, limitBookingsDayReached]);

        useEffect(() => {
    }, [values.dynamicValues]);

    useEffect(() => {
}, [totalPrize]);

    useEffect(() => {
        if (!userPriceData) return;

        const lightChecked = values.dynamicValues?.light;

        const price = lightChecked
            ? userPriceData.price_with_light
            : userPriceData.price;

        setTotalPrize(price * values.dates.length);
    }, [
        values.dynamicValues?.light,
        values.dates.length,
        userPriceData
    ]);

    useEffect(() => {
        if (values.phone_mandatory || values.id_facility_category == HARTU_FACILITY_PHONE) {
            setPhoneMandatory(true)
        } else {
            setPhoneMandatory(false)
        }
    }, [values.phone_mandatory, values.id_facility_category])

    useEffect(() => {
        validateForm(values);
    }, [lang]);

    const dispatch = useDispatch();
    useEffect(() => {
        const getCalculatedDiscount = (payload) => dispatch(calculateDiscount(payload))
        getCalculatedDiscount({ numBookings,
            userId,
            id_instancia,
            id_facility
        })
    }, [dispatch])

    const calculateLimits = async (dni, numBookings) => {
        const urlPage = `${process.env.REACT_APP_API_URL_BASE}hartu/frontend/bookings/calculate_limits`
        let sid = sessionStorage.getItem('uzky');
        const response = await fetch(urlPage, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "x-api-key": sessionStorage.getItem('instancek'),
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                id_instancia: id_instancia,
                numBookings: numBookings,
                dni: dni,
                id_facility: id_facility,
                sid: sid
            }),
        })

        if (response.status === 401) {
            sessionStorage.clear();
            window.location.href = "/";
            return true;
        }

        const data = await response.json();

        setLimitBookingsMonthReached(data.data.limit_bookings_month_reached);
        setLimitBookingsDayReached(data.data.limit_bookings_day_reached);
        setLimitBookingsMonth(Number(data.data.limit_bookings_month));
        setLimitBookingsDay(Number(data.data.limit_bookings_day));

        return data.data.limit_bookings_month_reached || data.data.limit_bookings_day_reached;
    };

    const parseTributariaCombination = (combinationString) => {
        return combinationString
            .split(';')
            .filter(Boolean)
            .reduce((result, value, index, array) => {
                if (index % 2 === 0) {
                    result[value] = String(array[index + 1] ?? '');
                }
                return result;
            }, {});
    };

    const getTributariaPriceForSelection = (dynamicValues, prices, nBookings) => {
        if (!Array.isArray(prices)) {
            return 0;
        }

        for (const item of prices) {
            if (!item?.combinations) {
                continue;
            }

            const combination = parseTributariaCombination(item.combinations);
            const combinationKeys = Object.keys(combination);

            const match = combinationKeys.every((key) => {
                const dynamicValue = String(dynamicValues[key] ?? '0');
                const combinationValue = String(combination[key]);

                return dynamicValue === combinationValue && dynamicValue !== '';
            });

            if (match) {
                setTributariaPrice(item.price * nBookings);
                setTotalPrize(item.price * nBookings);
                return parseFloat(item.price * nBookings) || 0;
            }

        }

        return 0;
    };

    useEffect(() => {
        if (!tributariaPrices) {
            return;
        }

        setTributariaPrice(getTributariaPriceForSelection(values.dynamicValues, tributariaPrices, dates.length));
        setUserPriceConvert(getTributariaPriceForSelection(values.dynamicValues, tributariaPrices, dates.length));
    }, [tributariaPrices, JSON.stringify(values.dynamicValues)], dates);

    const {
        hartu,
        userDiscount,
        userPrice=0,
        userPriceWithoutDiscount,
        userPriceWithLight,
        userPriceWithoutDiscountLight
    } = useSelector(
        ({ hartu }) => ({
            hartu: hartu,
            userDiscount: hartu?.discount?.data?.data?.discount,
            userPrice: hartu?.discount?.data?.data?.price,
            userPriceWithoutDiscount: hartu?.discount?.data?.data?.price_without_discount,
            userPriceWithLight: hartu?.discount?.data?.data?.price_with_light,
            userPriceWithoutDiscountLight: hartu?.discount?.data?.data?.price_without_discount_light,
        })
    )

    const [userPriceConvert, setUserPriceConvert] = useState(0)
    const [userPriceWithouDiscConvert, setUserPriceWithoutDiscConvert] = useState(0)

    useEffect(() => {
        if (!userPrice && !userPriceWithLight) return;

        const light = Boolean(values.dynamicValues?.light);

        let basePrice = light
            ? (userPriceWithLight ?? userPrice)
            : userPrice;

        let nbookings = values.dates.length || 1;

        // tributaria SIEMPRE pisa lo demás
        if (tributariaPrices && Array.isArray(tributariaPrices) && tributariaPrice >= 0) {
            basePrice = tributariaPrice;
            nbookings = 1;
        }

        const finalPrice = parseFloat(basePrice || 0);

        setUserPriceConvert((finalPrice * nbookings).toFixed(2));
        setTotalPrize(finalPrice * nbookings);

    }, [
        userPrice,
        userPriceWithLight,
        tributariaPrice,
        tributariaPrices,
        values.dates.length,
        values.dynamicValues?.light
    ]);

    const initialTouchedDynamic = React.useMemo(() => {
        const obj = {};
        (dynamicFields || []).forEach(f => {
            obj[f.name] = false;
        });
        return obj;
    }, [dynamicFields]);

    if (!isFormReady) {
        return null;
    }

    return (
        <form className="hartuBookingform" data-lang={lang} onSubmit={handleSubmit}>
            <ScrollToError />
            <div className='hartuBookingForm__days-banner'>
                <div
                    className="backButton"
                    aria-label={t.booking_form_change_date_data[lang]}
                    onClick={() => closeForm()}
                >
                    <span className="arrow">←</span>
                    <span>{t.go_back_dates[lang]}</span>
                </div>
                <div
                    className="hartuBookingForm__day-time-card"
                >
                    <HartuDateTimeBanner
                        dates={dates}
                        lang={lang}
                    />
                </div>
            </div>
            <div className="hartuBookingform__form">
                <div className="hartuBookingform__inputs--wrapper">
                    {dynamicFields
                        .filter(field => field.type?.toUpperCase() !== FIELD_TYPES.HIDDEN)
                        .map((field, index) => (
                            <div
                                key={field.name}
                                className="fade-in"
                                style={{ animationDelay: `${index * 0.05}s` }}
                            >
                                <HartuFacilityDynamicForm
                                    key={field.name}
                                    field={field}
                                    id={field.name}
                                    values={values}
                                    touched={touched.dynamicValues || initialTouchedDynamic}
                                    setFieldValue={setFieldValue}
                                    lang={lang}
                                />
                             </div>
                    ))}
                </div>
                    <div className="fade-in" style={{ animationDelay: `${(dynamicFields.length + 1) * 0.05}s` }}>
                        <FormGroup
                            errors={
                                touched.accept_policy && errors.accept_policy
                                    ? errors.accept_policy
                                    : null
                            }
                            aria-invalid={
                                touched.accept_policy && errors.accept_policy
                                    ? errors.accept_policy
                                    : null
                            }
                            id="accept_policy"
                            label=""
                            required
                            className="hartuBookingform__checkbox"
                        >
                            <FormCheckbox
                                errors={
                                    touched.accept_policy && errors.accept_policy
                                        ? errors.accept_policy
                                        : null
                                }
                                label={
                                    values.id_instancia === 77
                                    ? <AcceptPolicyLabelInstance77 lang={lang} />
                                    : <AcceptPolicyLabel lang={lang} />
                                }
                                name="politicsButtonCheck"
                                onChange={() =>
                                    setFieldValue(
                                        'accept_policy',
                                        !values.accept_policy
                                    )
                                }
                                value={values.accept_policy}
                            />
                        </FormGroup>
                    </div>
                    {state === STATES.ERROR && (
                        <FormError className="form-group__errors server-group__errors">
                            {errorBookingCode === 622
                                ? t.facility_disabled[lang]
                                : t.error_submit_default[lang]}
                        </FormError>
                    )}
                {limitBookingsDayReached && limitBookingsMonthReached ? (
                    <div className="hartuBookingform__limitsBookings">
                        <span>{t.limit_booking_month_day_with_num[lang].replace("{{num}}", limitBookingsDay).replace("{{num2}}", limitBookingsMonth)}</span>
                    </div>
                ) : limitBookingsDayReached ? (
                    <div className="hartuBookingform__limitsBookings">
                        <span>{t.limit_booking_day_with_num[lang].replace("{{num}}", limitBookingsDay)}</span>
                    </div>
                ) : limitBookingsMonthReached ? (
                    <div className="hartuBookingform__limitsBookings">
                        <span>{t.limit_booking_month_with_num[lang].replace("{{num}}", limitBookingsMonth)}</span>
                    </div>
                ) : null}
                <div className="hartuBookingform__submit" ref={submitButtonRef}>
                    <Button
                        disabled={false}
                        onClick={async () => {
                            const dynamicTouched = {};
                            Object.keys(values.dynamicValues).forEach(key => {
                                dynamicTouched[key] = true;
                            });

                            document.querySelectorAll(".error-message").forEach(el => el.remove());

                            setTouched({
                                postalCode: true,
                                people: true,
                                accept_policy: true,
                                price: true,
                                dynamicValues: dynamicTouched
                            });

                            const validationErrors = await validateForm();

                            let dynamicErrors = {};
                            if (dynamicValidationSchema) {
                                try {
                                    await dynamicValidationSchema.validate(values.dynamicValues, { abortEarly: false });
                                } catch (error) {

                                    if (error.inner && error.inner.length > 0) {
                                        error.inner.forEach(err => {
                                            if (err.path) {
                                                dynamicErrors[err.path] = err.message;
                                            }
                                        });
                                    } else if (error.path) {
                                        dynamicErrors[error.path] = error.message;
                                    } else if (Array.isArray(error.errors) && error.errors.length > 0) {
                                        dynamicErrors[Object.keys(values.dynamicValues)[0] || ''] = error.errors[0];
                                    }
                                }
                            }

                            const allErrors = { ...validationErrors };
                            if (Object.keys(dynamicErrors).length > 0) {
                                allErrors.dynamicValues = dynamicErrors;
                            }

                            // Setear los errores en formik
                            if (Object.keys(allErrors).length > 0) {
                                setErrors(allErrors);
                            }

                            if (Object.keys(validationErrors).length > 0 || Object.keys(dynamicErrors).length > 0) {
                                if (allErrors.dynamicValues && Object.keys(allErrors.dynamicValues).length > 0) {
                                    Object.entries(allErrors.dynamicValues).forEach(([key, value]) => {
                                        let errorElement = document.getElementById('dynamicValues.' + key);

                                        if (errorElement) {
                                            const div = document.createElement("div");
                                            div.textContent = value;
                                            div.className = "error-message";

                                            errorElement.insertAdjacentElement("afterend", div);
                                            try {
                                                errorElement.focus({ preventScroll: true });
                                            } catch (e) {
                                                console.warn('No se pudo hacer focus en el campo con error', firstErrorField);
                                            }
                                        }
                                    });
                                }
                                return;
                            }

                            const isLimited = await calculateLimits( values.dynamicValues.dni, values.dates.length);
                            if (isLimited) {
                                return;
                            }

                            setTouched({
                                ...touched,
                                dynamicValues: {}
                            });

                            validateForm().then( (validationErrors) => {
                                if (
                                    Object.keys(validationErrors).length === 0
                                ) {
                                    setDynamicFieldsValues({ ...values.dynamicValues });

                                    const urlPage = `${process.env.REACT_APP_API_URL_BASE}mi_pago/frontend/show_mi_pago_modal`;
                                    let sid = sessionStorage.getItem('uzky');
                                    setLoading(true);
                                    //TODO comprobar si se han cargado los pellets
                                    fetch(urlPage, {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            "x-api-key": sessionStorage.getItem('instancek'),
                                            'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                        },
                                        body: JSON.stringify({
                                            id_instancia: values.id_instancia,
                                            total_price: totalPrize,
                                            sid: sid,
                                            hasLightCheck: values.hasLightCheck,
                                            blocksForRent : values.dates.length,
                                            id_facility: id_facility,
                                            num_pellets: values.numPellets,
                                            dynamicValues: values.dynamicValues
                                        }),
                                    })
                                    .then((response) => {
                                        let rsp = response.json();
                                        if (response.status == 401) {
                                            sessionStorage.clear();
                                            window.location.href="/";
                                        }

                                        if (response.status != 200 && response.status != 401) {
                                            throw new Error(
                                                'Error al mostrar el modal de pago'
                                            )
                                        }

                                        return rsp;
                                    })
                                    .then((data) => {
                                        setLoading(false);
                                        if (data.code !== 200) {
                                            dispatch(setHartuErrorModal({
                                                isOpen: true,
                                                message: t.error_generic[lang],
                                            }));
                                            return;
                                        }

                                        if (data.data.mipago_modal === true) {
                                            setMiPagoModal(true)
                                            //TODO Hay que seguir ddesde aqui
                                            setTotalPrize(data.data.total_price)
                                            if(data.data.price_has_changed === true) {
                                                setPriceChange(true)
                                                setTributariaPrice(data.data.tributaria_price)
                                            }
                                        } else {
                                            setMiPagoModal(false)
                                            setPriceChange(true)
                                        }
                                        setModalOpen(true)
                                    })
                                    .catch((error) => {
                                        dispatch(setHartuErrorModal({
                                            isOpen: true,
                                            message: t.error_generic[lang],
                                        }));

                                        setLoading(false);
                                    })
                                }
                            })
                        }}
                        type="button"
                    >
                        {tributariaPrices==null && payment_type==3
                        ?t.action_calculate_price[lang]
                        :t.action_book[lang]}
                    </Button>
                    {lightChecked ? (
                        <div className="hartuBookingform__discounts--wrapper">
                            <div className="finalPrice">
                                <label>{t.price_with_light?.[lang] || 'Precio con luz'}</label>
                                <span>{parseFloat(userPriceConvert).toFixed(2)} €</span>
                            </div>
                        </div>
                    )  : tributariaPrices==null && payment_type===3 ? ('')
                    : tributariaPrice >= 0 && payment_type === 3 ? (
                        <div className="hartuBookingform__discounts--wrapper">
                            <div className="finalPrice">
                                <label>{t.price_with_tributaria?.[lang] || 'Precio tributaria'}</label>
                                <span>{parseFloat(tributariaPrice).toFixed(2)} €</span>
                            </div>
                        </div>
                    )
                     : !userPriceWithoutDiscount && userPrice != 0 ? (
                        <div className="hartuBookingform__discounts--wrapper">
                            <div className="finalPrice">
                                <label>{t.price_without_discount[lang]}</label>
                                <span>{parseFloat(userPriceConvert).toFixed(2)} €</span>
                            </div>
                        </div>
                    ) : userPriceWithoutDiscount && userPrice != 0 ? (
                        <div className="hartuBookingform__discounts--wrapper">
                            <div className="withoutDiscount">
                                <label>{t.price_initial_discount[lang]}</label>
                                <span>{userPriceWithouDiscConvert} €</span>
                            </div>
                            <div className="finalPrice">
                                <label>{t.price_with_discount[lang]}</label>
                                <span>{parseFloat(userPriceConvert).toFixed(2)} €</span>
                            </div>
                            <div className="discount">
                                <label>({t.discount_type[lang]}: {userDiscount})</label>
                            </div>
                        </div>
                    )
                    : ''}
                </div>
            </div>
            <TributariaModal
                title={t.confirmacion_reserva[lang]}
                id="dialog-content-mi-Pago"
                isOpened={isModalTributariaOpen}
                handleClose={handleTributariaClose}
                lang={lang}
                instanceID={values.id_instancia}
                total_price={totalPrize}
                tributaria_price={tributariaPrice}
                id_facility={values.id_facility}
                people={values.people}
                phone={values.phone}
                email={values.email}
                dni={values.dni}
                cp={values.postalCode}
                name={values.username}
                lastname={values.surnames}
                hasLightCheck={values.hasLightCheck}
                hidePayLaterButton={!Boolean(parseInt(can_pay_later))}
                numPellets={values.numPellets}
                id_user={userId}
                bookingDate={values.dates}
                startBookingHour={values.time}
                id_facility_type={values.facility_type}
                facilityName={facilityName}
                dynamicsFields={dynamicFieldsValues}
            >
            </TributariaModal>

            {isModalOpen ?
                (isMiPagoModal ?
                    (isPriceChanged ?
                        (
                            <PrecioCambiado
                                title={t.confirmacion_reserva[lang]}
                                id="dialog-content-mi-Pago"
                                isOpened={isModalOpen}
                                handleClose={handleClose}
                                lang={lang}
                                total_price={totalPrize}
                                tributaria_price={tributariaPrice}
                                bookingDate={values.dates}
                                startBookingHour={values.time}
                                facilityName={facilityName}
                                handleYesButton={ () => {
                                    handleClose();
                                    handleOpenTributaria()
                                }}
                            >
                            </PrecioCambiado>
                        ) :
                        (
                            <MiPagoModal
                                title={t.confirmacion_reserva[lang]}
                                id="dialog-content-mi-Pago"
                                isOpened={isModalOpen}
                                handleClose={handleClose}
                                lang={lang}
                                instanceID={values.id_instancia}
                                total_price={totalPrize}
                                id_facility={values.id_facility}
                                people={values.people}
                                phone={values.phone}
                                email={values.email}
                                dni={values.dni}
                                cp={values.postalCode}
                                name={values.username}
                                lastname={values.surnames}
                                hasLightCheck={values.hasLightCheck}
                                hidePayLaterButton={!Boolean(parseInt(can_pay_later))}
                                id_user={userId}
                                bookingDate={values.dates}
                                startBookingHour={values.time}
                                id_facility_type={values.facility_type}
                                facilityName={facilityName}
                                numPellets={values.numPellets}
                                dynamicsFields={dynamicFieldsValues}
                            ></MiPagoModal>
                        )
                    ) : (
                        <Modal
                                closeModal={() => setModalOpen(false)}
                                isOpened={isModalOpen}
                                title={t.confirmacion_reserva[lang]}
                            >
                                <div className="hartuBookingform__confirmation">
                                    <h3>{t.datos_reserva[lang]}</h3>
                                    <div className="hartuBookingform__confirmation_content_modal">
                                        <div>
                                            <i className="fa-solid fa-building fa-lg" />
                                            <p>{facilityName}</p>
                                        </div>
                                        <div>
                                            <i className="fa fa-calendar fa-lg" />
                                            <div className='diplayBlock'>
                                                {dates.map((date, index) => (
                                                    <div key={index}>
                                                        <p>{date}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        { totalPrize > 0 &&
                                            <div>
                                                <i className="fa fa-credit-card fa-lg" />
                                                <p>{`${totalPrize} €`}</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <Button
                                    className="hartuBookingform__confirmationButton"
                                    type="submit"
                                >
                                    {t.hartu_confirm_booking[lang]}
                                </Button>
                            </Modal>
                    )
                ): ""
                }
                <ErrorModal
                    isOpen={errorModal?.isOpen}
                    message={errorModal?.message}
                    cancelText={t.cancel[lang]}
                    onClose={() => dispatch(setHartuErrorModal({ isOpen: false, message: '' }))}
                    colorMain={getComputedStyle(document.documentElement).getPropertyValue('--color-main')}
                />
        </form>
    )
})

export default HartuFacilityBookingForm
